import React from 'react';
import * as asyncLoad from '../util/asyncLoad';
import { odocComsFiles } from '../constants/fileConfig';
import Loading from './Loading';

export default class OdocModelAndSensitive extends React.Component {
    constructor() {
        super();
        this.state = {
            hasLoad: false,
        };
    }
    componentDidMount() {
        const init = () => {
            this.setState({ hasLoad: true});
        }
        if (!window.weaOdoc)
            asyncLoad.asyncLoadModule('f_odoc', odocComsFiles, init);
    }
    render() {
        const { hasLoad } = this.state;
        if (hasLoad || window.weaOdoc) {
            const { commonParam, odocInfo, tabKey } = this.props;
            const { OdocModelAndSensitiveCom } = window.weaOdoc.components || {};
            const { odocModelAndSensitiveStore } = window.weaOdoc.store || {};
            return (
                <OdocModelAndSensitiveCom odocModelAndSensitiveStore={odocModelAndSensitiveStore} commonParam={commonParam} odocInfo={odocInfo} tabKey={tabKey}/>
            )
        } else {
            return (<Loading />);
        }
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/asyncComps/OdocModelAndSensitive.js